import { gql } from '@apollo/client';

export const getDomain = gql`
  query getDomain($domain: String!) {
    getDomain(domain: $domain) {
      domain
      videocationCatalog {
        id
      }
    }
  }
`;

export const getUser = gql`
  query getUser($userSub: UUID) {
    getUser(userSub: $userSub) {
      email
      id
      lastLoginAt
      memberships {
        createdAt
        invitedAt
        organization {
          name
          type
          updatedAt
          archived
          archivedAt
          createdAt
          createdFrom
          id
          invoiceAddress
          invoiceCity
          invoiceCountry
          invoiceEmail
          invoiceMunicipality
          invoiceName
          invoiceNote
          invoicePeriod
          invoiceSendVia
          invoiceZip
          legacyUUID
          organizationNumber
          membersCount
          hasActiveScimClient
          subscription {
            id
            expirationDate
            seats
            status
            updatedAt
            product {
              name {
                value
              }
              id
              description {
                value
              }
            }
          }
        }
        role
        updatedAt
      }
      name
      subscriptions {
        id
        seats
        status
        userId
        expirationDate
      }
    }
  }
`;
